import { RegisterModule } from '@/typings/common'
import { createMapper, registerModule as vuexRegisterModule, Module } from 'vuex-smart-module'
import {
  LKReportState,
  LKReportGetters,
  LKReportMutations,
  LKReportActions,
} from './store'
import { MODULE_NAME } from '../utils'

const storeModule = (
  new Module({
    namespaced: true,
    state: LKReportState,
    getters: LKReportGetters,
    mutations: LKReportMutations,
    actions: LKReportActions,
  })
)

const mapper = createMapper(storeModule)

export {
  storeModule as LKReportStoreModule,
  mapper as LKReportMapper,
}

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
